export default __webpack_public_path__ + "static/media/insta-2-comp.f1261a52.jpg";